var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 14.4987C5.05456 14.4987 2.66675 12.1109 2.66675 9.16536C2.66675 6.21985 5.05456 3.83203 8.00008 3.83203C10.9456 3.83203 13.3334 6.21985 13.3334 9.16536C13.3301 12.1095 10.9442 14.4954 8.00008 14.4987ZM8.00008 5.16536C5.79094 5.16536 4.00008 6.95623 4.00008 9.16536C4.00008 11.3745 5.79094 13.1654 8.00008 13.1654C10.2092 13.1654 12.0001 11.3745 12.0001 9.16536C11.9975 6.95729 10.2082 5.16794 8.00008 5.16536ZM8.66675 9.83203H7.33342V6.4987H8.66675V9.83203ZM12.8621 5.6367L11.5287 4.30336L12.4714 3.3607L13.8047 4.69403L12.8627 5.63603L12.8621 5.6367ZM10.0001 3.16536H6.00008V1.83203H10.0001V3.16536Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimer);
export default __webpack_public_path__ + "static/media/ic-timer.07e8213582420567a6324300dda787b0.svg";
export { ForwardRef as ReactComponent };